export default __webpack_public_path__ + "static/media/orders-table-reject.ef323abf.svg";